<template>
    <div>
        <competence-cards-list-loading v-if="loading"></competence-cards-list-loading>
        <list-component v-else-if="anyCompetenceCards" :rows="competenceCards" class="c-list-component--competence-cards  t-background-white-grey"></list-component>
    </div>
</template>

<script>
import CompetenceCardsListLoading from './CompetenceCardsListLoading';
import ListComponent from '@/components/vue-components/list-component/ListComponent.vue';

export default {
    name: 'CompetenceCardsList',
    components: {
        CompetenceCardsListLoading,
        ListComponent,
    },
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        competenceCards: {
            type: Array,
            default: ([])
        }
    },

    computed: {
        anyCompetenceCards() {
          return (!this.loading && this.competenceCards.length > 0);
        }
    }
}
</script>
